import axios from "@/libs/axios";

function isMainUnit(unit) {
  if (!unit) return false;
  const value = unit.is_main_unit;
  return value === 1 || value === true || value === "1";
}

export async function fetchMainUnitsForWizard(params = {}, { mainUnitOnly = true } = {}) {
  const { data } = await axios.get("v1/unit", {
    params: {
      ...(mainUnitOnly ? { is_main_unit: 1 } : {}),
      with: "router:id,id_tenant",
      max: 50,
      sortBy: "description",
      sortDesc: false,
      ...params,
    },
  });

  if (!data?.success) return [];

  const units = data.data || [];
  return mainUnitOnly ? units.filter(isMainUnit) : units;
}
